import { useState } from "react";
import MainLayout from "../../layout/MainLayout";
import { Button2, QuickActionSelect, ToggleButton } from "../index";
import plusIcon from "../../assets/icons/plus.png";
import { DatePicker } from "antd";
import recieptCheckIcon from "../../assets/icons/reciept-check.png";
import AllGroups from "./AllGroups";
import ExpensesDetails from "./ExpensesDetails";
import AllExpenses from "./AllExpenses";
import { useNavigate } from "react-router-dom";
import plusWhiteIcon from "../../assets/icons/plus-circle-white.png";
import { useGroups } from "../../data/live";

const componentForTab = (tab) => {
  switch (tab) {
    case "All Expenses":
      return { value: "All Expenses", component: <AllExpenses /> };
    case "Expenses Details":
      return { value: "Expenses Details", component: <ExpensesDetails /> };
    case "All Groups":
    default:
      return { value: "All Groups", component: <AllGroups /> };
  }
};

const SplitPayment = ({ initialTab = "All Groups" }) => {
  const { source } = useGroups();
  const [selectedComponent, setSelectedComponent] = useState({
    ...componentForTab(initialTab),
  });

  const navigate = useNavigate();

  const onToggle = (value) => {
    switch (value) {
      case "All Groups":
        setSelectedComponent({ value: value, component: <AllGroups /> });
        break;
      case "All Expenses":
        setSelectedComponent({ value: value, component: <AllExpenses /> });
        break;
      case "Expenses Details":
        setSelectedComponent({
          value: value,
          component: <ExpensesDetails />,
        });
        break;
      default:
        setSelectedComponent({ value: "All Groups", component: <AllGroups /> });
    }
  };
  return (
    <>
      <MainLayout 
        expand={false}
        NavName={
          <div className="d-flex align-items-center gap-2">
            <span>Split Payment</span>
            {source === "api" && (
              <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle fs10px">
                LIVE
              </span>
            )}
          </div>
        }
        navbarChildren={
          <QuickActionSelect className="rounded-5" />
        }
      >
        <div>

          <div className="container mt-5">
            <div className="row">
              <div className="d-flex align-items-center justify-content-md-between justify-content-center flex-wrap flex-md-nowrap gap-md-0 gap-3">
                <ToggleButton
                  options={["All Groups", "All Expenses", "Expenses Details"]}
                  defaultValue={initialTab}
                  onChange={(value) => onToggle(value)}
                />

                <div className="d-flex gap-2 align-items-center flex-md-wrap flex-wrap justify-content-center">
                  {selectedComponent.value === "All Expenses" && (
                    <DatePicker
                      className="rounded-pill"
                      placeholder="Custom Date"
                    />
                  )}

                  {!(selectedComponent.value === "Expenses Details") && (
                    <Button2
                      buttonName={"Add Expenses"}
                      icon={
                        <img
                          src={
                            selectedComponent.value === "All Groups"
                              ? plusIcon
                              : plusWhiteIcon
                          }
                          alt="add"
                        />
                      }
                      onClick={() => navigate("/add-expenses")}
                      className={
                        selectedComponent.value === "All Groups"
                          ? "btn-outline-success"
                          : "btn-dark"
                      }
                      divClassName={"gap-2"}
                    />
                  )}

                  {!(selectedComponent.value === "All Expenses") && (
                    <Button2
                      buttonName={"New Group"}
                      icon={<img src={plusWhiteIcon} alt="add" />}
                      className={"btn-dark "}
                      divClassName={"gap-2"}
                      onClick={() => navigate("/create-group")}
                    />
                  )}

                  {selectedComponent.value === "All Expenses" && (
                    <Button2
                      buttonName={"Settle Up"}
                      icon={<img src={recieptCheckIcon} alt="" />}
                      className={"btn-outline-success "}
                      divClassName={"gap-2"}
                      onClick={() => navigate("/settleup")}
                    />
                  )}
                </div>
              </div>

              {selectedComponent.component}
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default SplitPayment;
